<script>
import TableWidgetBuilder from '@/components/Home/CustomDashboard/TableWidgetBuilder.vue';
import PermissionDeniedWidget from '@/components/Home/PermissionDeniedWidget.vue';
export default {
  components: { TableWidgetBuilder, PermissionDeniedWidget },
  props: {
    tables: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<template>
  <div>
    <template v-for="(table, i) in tables" :key="i">
      <TableWidgetBuilder v-if="table.accessible" :key="i" :table="table" />

      <PermissionDeniedWidget
        v-else
        :chartConfig="table"
        class="permission-denied-table"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.permission-denied-table {
  height: 40rem;
  margin-bottom: 1rem;
}
</style>
